module.exports = __webpack_public_path__ + "img/churu.86f9f421.png";